import { Mitarbeiter_FeiertagskontoKontoausgleichArt } from '@/gql/graphql';

export class Kontoausgleiche {
  constructor({
    datum,
    art,
    bemerkung,
    tage,
  }: {
    datum: string;
    art: KontoausgleicheArt;
    bemerkung: string;
    tage: number;
  }) {
    this.datum = datum;
    this.art = art;
    this.bemerkung = bemerkung;
    this.tage = tage;
  }
  datum: string;
  art: KontoausgleicheArt;
  bemerkung: string;
  tage: number;
}

export enum KontoausgleicheArt {
  FEIERTAGSAUSZAHLUNG = 'Feiertagsauszahlung',
  FEIERTAGSKORREKTUR = 'Feiertagskorrektur',
}

export const mappedKontoausgleicheArt = (
  status: Mitarbeiter_FeiertagskontoKontoausgleichArt,
): KontoausgleicheArt => {
  switch (status) {
    case Mitarbeiter_FeiertagskontoKontoausgleichArt.Feiertagsauszahlung:
      return KontoausgleicheArt.FEIERTAGSAUSZAHLUNG;
    case Mitarbeiter_FeiertagskontoKontoausgleichArt.Feiertagskorrektur:
      return KontoausgleicheArt.FEIERTAGSKORREKTUR;
  }
};

export const mappedGqlArtToDomainArt = (
  status: KontoausgleicheArt,
): Mitarbeiter_FeiertagskontoKontoausgleichArt => {
  switch (status) {
    case KontoausgleicheArt.FEIERTAGSAUSZAHLUNG:
      return Mitarbeiter_FeiertagskontoKontoausgleichArt.Feiertagsauszahlung;
    case KontoausgleicheArt.FEIERTAGSKORREKTUR:
      return Mitarbeiter_FeiertagskontoKontoausgleichArt.Feiertagskorrektur;
  }
};
